module.exports = __webpack_public_path__ + "img/bisonte-2.ca822067.png";